// extracted by mini-css-extract-plugin
export default {"default-metadata-container":"default-metadata-container-8b3e","key-value-pair":"key-value-pair-fd77","mobile-value":"mobile-value-8b7a"};